module.exports = __webpack_public_path__ + "img/cat-11.67d7f217.png";